import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

//third party
import OTPInput, { ResendOTP } from "otp-input-react";
//icons
import { ReactComponent as ConfirmIcon } from "assets/images/icons/confirm.svg";

const OTPForm = (props) => {
  const { showConfirm, onConfirm } = props;
  const { t } = useTranslation();
  const [OTP, setOTP] = useState("");
  return (
    <>
      {showConfirm && (
        <MDTypography textAlign="center" fontWeight="bold">
          تایید کد
        </MDTypography>
      )}
      <MDTypography textAlign="center" component="p" color="text" mb={2} mt={3} fontSize="sm">
        کد برای شماره{" "}
        <MDTypography
          textAlign="center"
          component="span"
          color="text"
          fontWeight="bold"
          mb={2}
          mt={3}
        >
          "00232567" &nbsp;
        </MDTypography>
        ارسال شد
      </MDTypography>
      {!showConfirm && (
        <MDBox mb={3} display="flex" justifyContent="center">
          <MDTypography
            fontSize="xs"
            variant="button"
            fontWeight="bold"
            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
            color="info"
          >
            {t("buttons.changeNumber")}
          </MDTypography>
        </MDBox>
      )}
      <MDBox mt={1} mb={2} display='flex' justifyContent="center">
        <MDButton
          color="primary"
          sx={({ breakpoints }) => ({
            width: "124px",
            [breakpoints.down("xl")]: {
              display: "none",
            },
          })}
        >
          {t("buttons.sendCode")}
        </MDButton>
        <OTPInput
          focusStyle={"otp-input-focus"}
          inputClassName={"otp-input"}
          value={OTP}
          onChange={setOTP}
          autoFocus
          OTPLength={5}
          otpType="number"
          disabled={false}
          secure
        />
      </MDBox>
      <MDBox  display='flex' justifyContent="center">
      <MDButton
        color="primary"
        sx={({ breakpoints }) => ({
          width: "124px",
          [breakpoints.up("xl")]: {
            display: "none",
          },
        })}
      >
        {t("buttons.sendCode")}
      </MDButton>
      </MDBox>
      <MDBox display="flex" justifyContent="center">
        <ConfirmIcon />
      </MDBox>
      {/* <MDBox mt={3} mb={showConfirm ?0 :2} display="flex" justifyContent="center">
        {showConfirm ? (
          <MDButton variant="gradient" color="success" onClick={onConfirm}>
            {t("buttons.confirm")}
          </MDButton>
        ) : (
          <MDButton variant="outlined" color="dark">
            {t("buttons.resend")}
          </MDButton>
        )}
      </MDBox> */}
    </>
  );
};

export default OTPForm;
